import requestUtil from "../../helpers/requestUtil";
import { setLoading } from "../common/Loader/slice";
import { setInboxMessages, setLodingFlagDecrement, setLodingFlagIncrement, setTotalCount } from "./slice";
import * as Toasts from '../common/Toastify';


export const getInboxMessageData = ({ url, params }) => {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await requestUtil(`${url}`, "POST", { ...params });
      if(response){
        const inboxMessages = response?.getEmailInboxMessages?.length > 0 ? response?.getEmailInboxMessages :[]
        dispatch(setInboxMessages(inboxMessages))
        dispatch(setTotalCount(response?.totalCount))
      }
    } catch (error) {
      Toasts.error(error.message)
    } finally {
      dispatch(setLoading(false));
    }
  };
};

export const deleteInboxMsgData = ({url,inboxMsgId, candidateUniqueId, employerUniqueId}) => {
  return async (dispatch,getState) => {
    dispatch(setLodingFlagIncrement());
    const state = getState();
    const {data} = state.inbox;
    const newInboxData = JSON.parse(JSON.stringify(data));
  try {
      const response = await requestUtil(`${url}/Employers/delete-inbox-Message-details?MessageTrackingId=${inboxMsgId}&candidateUniqueId=${candidateUniqueId}&employerUniqueId=${employerUniqueId}`, 'DELETE');
     if(response){
      const updateInboxData = newInboxData.filter( notificationData => notificationData?.messageTrackingId !== inboxMsgId)
      dispatch(setInboxMessages(updateInboxData));
      Toasts.success(response.message)
     }
  } catch (error) {
      Toasts.error(error.message)
  }
  finally {
      dispatch(setLodingFlagDecrement())
  }
}
}

export const updateInboxStatus = ({url,inboxStatusParams}) => {
  return async (dispatch,getState) => {
      dispatch(setLodingFlagIncrement());
      const state = getState()
      const {messageTrackingId,markAsMessageRead} = inboxStatusParams
      const {data} = state.inbox;
      const newInboxData = JSON.parse(JSON.stringify(data));
      try {
        console.log({inboxStatusParams});
          const response = await requestUtil(`${url}/Employers/MarkAsReadForInboxMessage`,'POST', { ...inboxStatusParams });
          if(response){
              const updateNotificationData = newInboxData?.map(item => {
                  if(item?.messageTrackingId === messageTrackingId){
                      return {...item,isRead:markAsMessageRead}
                  }
                  return item
              })
              dispatch(setInboxMessages(updateNotificationData));
          }
      } catch (error) {
          Toasts.error(error.message)
      }
      finally {
          dispatch(setLodingFlagDecrement())
      }
  }
}

export function getEmailDetails({ url }) {
  return async (dispatch) => {
      dispatch(setLodingFlagIncrement());
      try {
          const response = await requestUtil(`${url}`, "GET");
          return response;
      } catch (error) {
          return error.message;
      } finally {
          dispatch(setLodingFlagDecrement());
      }
  };
}

export function sendEmail({ url, params }) {
  return async (dispatch) => {
      dispatch(setLodingFlagIncrement());
      try {
          const response = await requestUtil(`${url}`, "POST", { ...params });
          Toasts.success("Email sent successfully!");
          return response;
      } catch (error) {
          Toasts.error("Email Not sent!");
          return error.message;
      } finally {
          dispatch(setLodingFlagDecrement());
      }
  };
}

export function sendAllEmailbtn(url) {
  return async (dispatch) => {
      dispatch(setLodingFlagIncrement());
      try {
          const response = await fetch(url);
          return response;
      } catch (error) {
          return error.message;
      } finally {
          dispatch(setLodingFlagDecrement());
      }
  };
}
export const archievedInboxMsg = ({url,inboxStatusParams}) => {
  return async (dispatch,getState) => {
      dispatch(setLodingFlagIncrement());
      const state = getState()
      const {messageTrackingId} = inboxStatusParams
      const {data} = state.inbox;
      const newInboxData = JSON.parse(JSON.stringify(data));
      try {
        // console.log({inboxStatusParams});
          const response = await requestUtil(`${url}/Employers/archived-for-email-inbox-messages`,'POST', { ...inboxStatusParams });
          if(response?.result){
              const updateInboxData = newInboxData?.filter(data => data?.messageTrackingId !== messageTrackingId);
              dispatch(setInboxMessages(updateInboxData));
              Toasts.success(response.message)
          }
      } catch (error) {
          Toasts.error(error.message)
      }
      finally {
          dispatch(setLodingFlagDecrement())
      }
  }
}
